var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvgAgentNotService = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E14747",
  d: "M71.43 8.571H8.571a2.866 2.866 0 0 0-2.857 2.857V60a2.866 2.866 0 0 0 2.857 2.857h62.857A2.866 2.866 0 0 0 74.286 60V11.428a2.866 2.866 0 0 0-2.857-2.857m-2.858 48.572H11.429V14.286h57.143zm-7.143 8.571H18.572v5.714h42.857z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E14747",
  d: "m32 48 8-7.571 7.429 8 4.142-4-7.428-8L52 29l-4-4.143-7.857 7.429-7.572-7.857-4.142 4L36 36.286l-8 7.571z"
})));
export default SvgSvgAgentNotService;